import axios from "axios";
import { getCookie, removeCookie } from './cookie';

export const publicAPI = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

export const privateAPI = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

privateAPI.interceptors.request.use(
    function (config) {
            const token = getCookie("token");
            if (token) {
                config.headers.Authorization = token;
            }
            let date = new Date();
            config.headers.localTime = date;
            config.headers.timeZoneOffset = date.getTimezoneOffset();
            return config;
        },
        function (error) {
            return Promise.reject(error);
        }
);
        
privateAPI.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (401 === error.response.status) {
            removeCookie("token");
            window.location.pathname = '/'
        }
        if (500 === error.response.status) {
            window.location.pathname = '/'
        }
        
        return Promise.reject(error);
    }
);